import React from "react";
import {
  BlueBirdTheme, Button, Loading, Typography,
} from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useBusiness from "../../hooks/useBusiness";

interface BusinessDeleteModalProps {
  useCustomHook: ReturnType<typeof useBusiness>;
}

const { danger, gray } = BlueBirdTheme.colors;

const BusinessDeleteModal = ({
  useCustomHook,
}: BusinessDeleteModalProps) => {
  const {
    idDeleteModal, setIdDeleteModal, onDelete, isUpdateLoading,
  } = useCustomHook;
  const onClose = () => setIdDeleteModal(null);
  return (
    <Modal
      isOpen={!!idDeleteModal}
      setOpen={onClose}
      title="Konfirmasi hapus data"
      body={
        <Typography
          level={5}
          color={gray.subtitle}
          fontWeight="medium"
        >
          Apakah Anda yakin ingin menghapus data?
        </Typography>
      }
      footer={
        <>
          <Button
            variant="text"
            onClick={onClose}
            disabled={isUpdateLoading}
          >Batal</Button>
          <Button
            backgroundColor={danger[500]}
            onClick={onDelete}
            leftIcon={isUpdateLoading && <Loading variant="circular" />}
            disabled={isUpdateLoading}
          >
            Ya, hapus
          </Button>
        </>
      }
    />
  );
};

export default BusinessDeleteModal;
